<mat-card>
    <mat-card-content>
        <div class="records">
            <div>
                <mat-form-field appearance="outline">
                    <input matInput (ngModelChange)="applyFilter($event)" placeholder="Search" ngModel>
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>
            <div [hidden]="true">
                <span>Showing you Login Records from</span>
                <mat-form-field appearance="outline">
                    <!-- <mat-label>Showing you Login Records from</mat-label> -->
                    <input matInput [matDatepicker]="dp" [formControl]="date">
                    <!-- <mat-hint>MM/YYYY</mat-hint> -->
                    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                    <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)"
                        panelClass="example-month-picker">
                    </mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="teamTable setTable">
            <mat-table [dataSource]="user_activity_list" matSort (matSortChange)="announceSortChange($event)">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <!-- Device Details Column -->
                <ng-container matColumnDef="device_details">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Device Details </mat-header-cell>
                    <mat-cell *matCellDef="let member" class="user_name">
                        <span class="mobile-label">Device Details:</span>
                        <!-- <img src="assets/images/users/{{member.device_details}}.jpg" alt=""> -->
                        <span class="fw-medium">
                            {{member?.device==null?"-":member?.device}}
                        </span>
                    </mat-cell>
                </ng-container>

                <!-- Mode Column -->
                <ng-container matColumnDef="browser">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Browser </mat-header-cell>
                    <mat-cell *matCellDef="let member" class="fs-13">
                        <span class="mobile-label">Browser:</span>
                       <span class="text-right">{{member?.browser==null?"-":member?.browser}}</span>
                    </mat-cell>
                </ng-container>

                <!-- Location of Access Column -->
                <ng-container matColumnDef="location_of_access">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Location of Access </mat-header-cell>
                    <mat-cell *matCellDef="let member" class="fs-13">
                        <span class="mobile-label">Loc. of Access:</span>
                        <span class="text-right">{{member?.city==null?"-":member?.city}}, {{member?.country_name==null?"-":member?.country_name}}</span>
                    </mat-cell>
                </ng-container>

                <!-- IP Address Column -->
                <ng-container matColumnDef="ip_address">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> IP Address </mat-header-cell>
                    <mat-cell *matCellDef="let member" class="fs-13">
                        <span class="mobile-label">IP Address:</span>
                        <span class="text-right">{{member?.ip==null?"-":member?.ip}}</span>
                    </mat-cell>
                </ng-container>
                <!-- Time of Login Column -->
                <!-- <ng-container matColumnDef="time_of_login">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Time of Login </mat-header-cell>
                    <mat-cell *matCellDef="let member" class="fs-13"> {{member?.datetime}} </mat-cell>
                </ng-container> -->

                <!-- Action Column -->
                <!-- <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                    <mat-cell *matCellDef="let member">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item>
                                <span>View Details</span>
                            </button>
                            <button mat-menu-item>
                                <span>Edit Details</span>
                            </button>
                        </mat-menu>
                    </mat-cell>
                </ng-container> -->

                <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>


        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" aria-label="Select page of users"
            [length]="pageLength" (page)="pageChanged($event)"></mat-paginator>
    </mat-card-content>
</mat-card>